<template>
  <div>
    <multiselect
        v-model="selectedLookUps"
        :options="lookups"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        placeholder
        selectLabel=""
        selectedLabel=""
        tagPlaceholder=""
        deselectLabel=""
        label="text"
        track-by="value"
        openDirection="bottom"
        @select="select"
        @remove="select"
      />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  props: ['cellKey', 'gridData', 'filter', 'options'],
  data () {
    return {
      selectedLookUps: []
    }
  },
  computed: {
    ...mapState([
      'dataGrid_options'
    ]),
    lookUpTable () {
      return this.options.meta[this.cellKey].lookUpTable
    },
    lookUpTableDisplayColumn () {
      return this.dataGrid_options[this.lookUpTable].displayColumn
    },
    lookups () {
      const lookUpTableVals = $getGrid(this.lookUpTable)
      return (lookUpTableVals || []).map((row) => ({
        text: row[this.lookUpTableDisplayColumn],
        value: row.rowKey
      }))
    }
  },
  methods: {
    select () {
      this.$nextTick(() => {
        if (this.selectedLookUps.length) {
          const value = this.selectedLookUps.map((item) => {
            return item.value
          })

          Vue.set(this.filter, this.cellKey, value.join(','));
        } else {
          Vue.delete(this.filter, this.cellKey)
        }
      })
    }
  }
}
</script>
